import React, { FunctionComponent, memo } from 'react';
import { Box, Grid, Typography } from '@material-ui/core';
import Price from '../../../../gqlCommon/components/presentation/Price';
import priceBadgeStyles from './PriceBadgeStyles';
import clsx from 'clsx';
import IndicativeNumber from '../../../../common/components/indicativeNumber/IndicativeNumber';
import useScrollToSection from '../../../hooks/navigation/useScrollToSection';
import Translation from '../../../../common/components/translation/Translation';
import { PriceDisplayType } from '../../../../../../common/enum/PriceDisplayType';

export interface IPriceBadge {
  fullPrice: number;
  offerPrice: number;
  currency: string;
}

const PriceBadge: FunctionComponent<IPriceBadge> = memo(({ fullPrice, offerPrice, currency }) => {
  const { scrollToDisclaimer } = useScrollToSection();
  const styles = priceBadgeStyles();

  return (
    <Box className={styles.container}>
      <Grid container={true} direction={'row'} className={styles.textContainer} alignItems={'flex-end'}>
        <Grid item={true} xs={6}>
          <Typography component="p" className={clsx(styles.text, styles.oldPriceText)}>
            <Translation id={'trans__configurator__models_page__badge_old_title'} />
          </Typography>
        </Grid>
        <Grid item={true} xs={6}>
          <Box onClick={scrollToDisclaimer} className={styles.newPriceTitleContainer}>
            <Typography component="p" className={clsx(styles.text, styles.newPriceText)}>
              <Translation id={'trans__configurator__models_page__badge_new_title'} />
              <IndicativeNumber
                topOffset={2}
                dataTest="vehicle_total_price"
                className={clsx([styles.indicativeNumber, styles.boldLabel])}
                displayNumber={<Translation id="trans__configurator__indicative_numbers__vehicleTotalPrice" />}
              />
            </Typography>
          </Box>
        </Grid>
      </Grid>
      <Grid container={true} direction={'row'} className={styles.pricesContainer}>
        <Grid item={true} xs={6} className={styles.divider}>
          <Typography className={styles.oldPriceContainer}>
            <Price
              className={styles.price}
              component={'span'}
              price={fullPrice}
              display={'inline'}
              currency={currency}
              data-test={'offer:price:old'}
              priceDisplayType={PriceDisplayType.PRIMARY}
            />
          </Typography>
        </Grid>
        <Grid item={true} xs={6}>
          <Typography className={styles.newPriceContainer}>
            <Price
              className={[styles.price, styles.newPrice].join(' ')}
              component={'span'}
              price={offerPrice}
              display={'inline'}
              currency={currency}
              data-test={'offer:price:new'}
              priceDisplayType={PriceDisplayType.PRIMARY}
            />
          </Typography>
        </Grid>
      </Grid>
    </Box>
  );
});

export default PriceBadge;
